import Swiper from 'swiper/bundle';

const postSlider = new Swiper(".js-swiper-slider", {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: false,
    keyboard: {
        enabled: true,
    },
    grabCursor: true,
    observeParents: true,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false
    }
});

const relatedSlider = new Swiper(".js-swiper-related", {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 15,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination",
         clickable: true,
    },
});
